import React from 'react';
import Fade from 'react-reveal/Fade';
import box from '../Assets/box.png';
import bannerleft from '../Assets/bannerleft.png'

const Productb = () => {
  return (
    <div className="about-section-container">
      <Fade left>
      <div className="about-background-image-container">
        <img src={bannerleft} alt="" />
      </div>
      <div className="about-section-image-container">
        <img className='image' src={box} alt="" />
      </div>
      </Fade>
      <div className="about-section-text-container">
        {/* <p className="primary-subheading">About</p> */}
        <Fade right>
        <h1 className="product-primary-heading">
        Plant Based Reusable Containers
        </h1>
        <p className="product-primary-text">
        €2.99
        </p>
      </Fade>
        <Fade bottom>
        <div className="about-buttons-container">
          <button className="secondary-button">Buy Now</button>
        </div>
      </Fade>
      </div>
    </div>
  )
}

export default Productb